import styled from 'styled-components';

import { type ThemeTypes } from '../../../../../../../../types/Theme.namespace';

const Container = styled.div<{ backgroundColor: ThemeTypes.Colors }>`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.S8};
  align-items: center;

  padding: ${({ theme }) => theme.spacing.M16};

  border-radius: ${({ theme }) => theme.borderRadius.default};

  background-color: ${({ theme, backgroundColor }) =>
    theme.colors[backgroundColor]};
`;

export { Container };
